import { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
export function useCreateGenericChatActionPayload() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return useCallback(function (history) {
    var title = history.entries[0].configItem.title;
    var name = title ? formatMessage(title) : '';
    var dialogues = history.entries.map(function (entry, index) {
      var configItemTitle = formatMessage(entry.configItem.title);
      var humanMessage = entry.userInput;

      // The first message should show the config item title
      if (index === 0) {
        humanMessage = "".concat(configItemTitle, "\n\n").concat(humanMessage);
      }
      // Use the config item title as fallback if the human message is empty
      humanMessage = humanMessage.trim() || configItemTitle;
      return {
        agent_message: {
          content: entry.markdown
        },
        human_message: {
          content: humanMessage
        }
      };
    });
    return {
      name: name,
      dialogues: dialogues
    };
  }, [formatMessage]);
}